import React, { useState } from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap'
import { useLocation, useParams } from 'react-router-dom'
import { buildersInfo } from '../config/builderInfo'
import { theme } from '../theme/theme'

const TransactionPrint = () => {
  const { broker_id } = useParams()
  const [loading] = useState(false)
  const location = useLocation()
  const { formData, payment } = location.state || {}

  if (loading) return <p>Loading printing details...</p>

  const handlePrint = () => {
    const content = document.getElementById('print_page').innerHTML
    const printWindow = window.open('', '_blank')
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Transaction</title>
          <style>
            @page { size: A4; margin: 10mm; }
            body {
              font-family: Arial, sans-serif;
              margin: 1rem;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            @media print {
              .no-print { display: none !important; }
            }
          </style>
        </head>
        <body>
          ${content}
        </body>
      </html>
    `)

    printWindow.document.close()

    // Wait until the new window fully loads content
    printWindow.onload = () => {
      printWindow.focus()
      printWindow.print()

      // Close automatically once printing is done
      printWindow.onafterprint = () => {
        printWindow.close()
      }
    }
  }

  const textStyle = {
    fontSize: '14px',
    color: '#6c757d',
    marginBottom: '0rem',
  }

  const signatureStyle = {
    fontSize: '16px',
    marginTop: '6rem',
    marginLeft: '21rem',
    textAlign: 'center',
    fontStyle: 'italic',
  }

  return (
    <>
      <style>
        {`
          @media print {
            .no-print,
            .position-fixed,
            header,
            nav,
            aside {
              display: none !important;
            }

            body, html {
              margin: 0 !important;
              padding: 0 !important;
              background: #fff !important;
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
              font-size: 12px !important;
            }

            @page {
              size: A4 portrait;
              margin: 10mm;
            }

#print_page {
  width: 210mm;
  min-height: auto !important;
  height: auto !important;
  overflow: visible !important;
  page-break-inside: avoid !important;
  margin: 0 auto !important;
  box-sizing: border-box;
  background: white;
}



          }
        `}
      </style>

      <Container className="p-5" >
        <Row className="justify-content-end" id="print_page">
          <Col xs={12} md={10} lg={10}>
            <div>
              <Container>
                <Row>
                  <Col xs={12} sm={4}>
                    <img
                      src="/ishan.png"
                      alt="ishan logo"
                      className="text-center text-sm-end"
                      style={{ width: '90px' }}
                    />
                  </Col>
                  <Col xs={12} sm={6}>
                    <h2
                      className="fw-bold mt-0 text-start text-sm-start"
                      style={{ marginBottom: '-1rem', color: theme.colors.primary }}
                    >
                      {buildersInfo.name}
                    </h2>
                    <br />
                    <p className="text-center text-sm-start text-muted" style={textStyle}>
                      {buildersInfo.address}
                    </p>
                    <p className="text-start">Contact : {buildersInfo.contact_number}</p>
                  </Col>
                </Row>

                <Row style={{ marginBottom: '4rem', marginRight: '8rem' }}>
                  <Col>
                    <h4
                      className="ishan-copy mt-4"
                      style={{
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        color: theme.colors.secondary,
                      }}
                    >
                      {buildersInfo.name} Copy
                    </h4>
                  </Col>
                </Row>

                <Row className="text-center">
                  <Col>
                    <p
                      style={{
                        fontSize: '1.3rem',
                        margin: 0,
                        fontWeight: 'bold',
                      }}
                    >
                      I have released amount
                      <span className="text-danger" style={{ fontWeight: 'bold' }}>
                        {' '}
                        ₹ {formData?.paid_amount || payment?.paid_amount || 'N/A'}
                      </span>{' '}
                      on{' '}
                      {new Date(formData?.date || payment?.date).toLocaleDateString('en-GB', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      })}{' '}
                      by {formData?.method_type || payment?.method_type || 'N/A'} method.
                    </p>
                  </Col>
                </Row>

                <Row className="text-center mt-5">
                  <Col>
                    <p style={signatureStyle}>
                      <strong className="fw-bold">Signature with stamp</strong>
                    </p>
                  </Col>
                </Row>
              </Container>
            </div>

            <div style={{ marginTop: '3rem' }}>
              <div
                className="my-4 border-line"
                style={{
                  borderTop: '3px dashed ',
                  width: '100%',
                }}
              ></div>
            </div>

            <div style={{ marginTop: '3rem' }}>
              <Container>
                <Row>
                  <Col xs={12} sm={4}>
                    <img
                      src="/ishan.png"
                      alt="ishan logo"
                      className="text-center text-sm-end"
                      style={{ width: '90px' }}
                    />
                  </Col>
                  <Col xs={12} sm={6}>
                    <h2
                      className="fw-bold mt-2 text-start text-sm-start"
                      style={{ marginBottom: '-1rem', color: theme.colors.primary }}
                    >
                      {buildersInfo.name}
                    </h2>
                    <br />
                    <p className="text-center text-sm-start text-muted" style={textStyle}>
                      {buildersInfo.address}
                    </p>
                    <p className="text-start">Contact : {buildersInfo.contact_number}</p>
                  </Col>
                </Row>

                <Row style={{ marginBottom: '4rem', marginRight: '12rem' }}>
                  <Col>
                    <h4
                      className="agent-copy mt-4"
                      style={{
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        color: theme.colors.secondary,
                      }}
                    >
                      AGENT'S COPY
                    </h4>
                  </Col>
                </Row>

                <Row className="text-center">
                  <Col>
                    <p
                      style={{
                        fontSize: '1.3rem',
                        margin: 0,
                        fontWeight: 'bold',
                      }}
                    >
                      I have received amount
                      <span className="text-danger" style={{ fontWeight: 'bold' }}>
                        {' '}
                        ₹ {formData?.paid_amount || payment?.paid_amount || 'N/A'}
                      </span>{' '}
                      on{' '}
                      {new Date(formData?.date || payment?.date).toLocaleDateString('en-GB', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      })}{' '}
                      by {formData?.method_type || payment?.method_type || 'N/A'} method.
                    </p>
                  </Col>
                </Row>

                <Row className="text-center mt-5">
                  <Col>
                    <p style={signatureStyle}>
                      <strong className="fw-bold">Signature with stamp :</strong>
                    </p>
                  </Col>
                </Row>
              </Container>
            </div>


          </Col>
        </Row>
     

        <div style={{ marginTop: '6rem' , width:'100%', display: 'flex', justifyContent: 'end'}}>
              <Button
                variant="outline-secondary"
                className="fw-bold mb-2 no-print ms-auto"
                onClick={handlePrint}
                style={{ width: '150px' }}
              >
                <i className="bi bi-file-earmark-pdf"></i> Print
              </Button>
        </div>

      </Container>
    </>
  )
}

export default TransactionPrint
